export class GasWarningCenterType {
  static readonly TYPES: GasWarningCenterType[] = [
    new GasWarningCenterType("Regard 1000", "Regard_1000", "ig4uova8b960b4373p36elql3d", false),
    new GasWarningCenterType("Regard 2400", "Regard_2400", "jslknj42td29r7dh1lmaanm02l", true),
    new GasWarningCenterType("Regard 3000", "Regard_3000", "658d3a53gd00vfg39vapjdmh1o", true),
    new GasWarningCenterType("Regard 3000 plus", "Regard_3000_plus", "j0bo48o58l13193ce26c3bbe2v", true),
    new GasWarningCenterType("Regard 3900", "Regard_3900", "tgfjo729eh7qnckrcpoc343340", true),
    new GasWarningCenterType("Regard 7000", "Regard_7000", "fb37o9h4e11jj2l1gdnrbnla7u", true),
    new GasWarningCenterType("VarioGard", "VarioGard", "d85ien543t2h5c7mfqs4j8fo53", false),
  ];

  name: string;
  key: string;
  cantoImageId: string;
  hasExcelsheet: boolean;

  constructor(name: string, key: string, cantoImageId: string, hasExcelsheet: boolean) {
    this.name = name;
    this.key = key;
    this.cantoImageId = cantoImageId;
    this.hasExcelsheet = hasExcelsheet;
  }

  isMatchingProduct(productName: string): boolean {
    productName = productName.toLocaleLowerCase();
    const typeName = this.name.toLocaleLowerCase();
    if (this.key === "Regard_3000") {
      // One Regard 3900 product also includes the type name "Regard 3000". That must not match here.
      // Regard 3000 plus products are filtered
      return productName.includes(typeName) && productName.includes("basiseinheit") && !productName.includes("plus");
    }
    if (this.key === "Regard_3000_plus") {
      return productName.includes(typeName) && productName.includes("basiseinheit");
    }
    if (this.key === "Regard_7000") {
      return productName.includes("regard 7000 docking station");
    }
    return productName.includes(typeName);
  }
}
